import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'highlightSearch'
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, input: any): any {
    const regex = new RegExp(input, 'gi');
    const match = value.match(regex);

    if (!input) {
      return value;
    }

    if (!match) {
      return value;
    }
    const replacedValue = value.replace(regex, `<span class="fw-600 text-primary">${match[0]}</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue);
  }

}
